import { TRANSPORTATION_TAB } from "../../framework/tab/tabUtilsConstants";
import { TransportModes } from "../../utils/constant";
import images from "../../assets/images";

export const columnDefs = [
  {
    headerName: "",
    field: "isLocked",
    width: 25,
    locked: true,
    floatingFilter: false,
    resizable: false,
    hide: false,
  },
  {
    headerName: "Transport Id",
    field: "transportId",
    hide: true,
  },
  {
    headerName: "Short Code",
    field: "shortCode",
    width: 120,
  },
  {
    headerName: "Transporter Name",
    field: "transportName",
    width: 180,
  },
  {
    headerName: "Transporter Id (GSTIN)",
    field: "gstin",
    width: 200,
  },
  {
    headerName: "Branch",
    field: "branch",
    width: 200,
  },
  {
    headerName: "Transport Address",
    field: "transportAddress",
    width: 200,
  },
  {
    headerName: "Building Name",
    field: "buildingName",
    width: 150,
  },
  {
    headerName: "Pin Code",
    field: "pincode",
    width: 120,
  },
  {
    headerName: "Transport Mode",
    field: "transportMode",
    width: 120,
  },
  {
    headerName: "Min Weight",
    field: "minWeight",
    width: 120,
  },
  {
    headerName: "Mobile Number",
    field: "mobileNumber",
    width: 150,
  },
  {
    headerName: "Email",
    field: "email",
    width: 150,
  },
];

export const columnDefsFunctions = {
  isLocked: {
    cellRendererFramework: (params) => {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {params.data.isLocked && <img src={images.locked} alt="" />}
        </div>
      );
    },
    // headerComponentFramework: (params) => {
    //   return <img src={images.locked} alt="" />;
    // },
  },

  transportMode: {
    valueGetter: (params) => {
      if (params?.data?.transportMode) {
        return params?.data?.transportMode;
      }
    },
  },
};

export const transformPayload = (transportData) => {
  return {
    transportId: transportData?.transportId,
    shortCode: transportData?.shortCode || "",
    transportName: transportData?.transportName || "",
    transportAddress: transportData?.transportAddress || "",
    buildingName: transportData?.buildingName || "",
    pincode: transportData?.pincode || "",
    branch: transportData?.branch,
    transportMode: transportData?.transportMode?.label || "",
    minWeight: transportData?.minWeight,
    mobileNumber: transportData?.mobileNumber || "",
    email: transportData?.email || "",
    gstin: transportData?.gstin || "",
  };
};

export const initial_state_Transport = {
  type: TRANSPORTATION_TAB,
  label: "Transport",
  allowMultipleTabs: false,
};
